<template>
  <div>
    <h1>Gestion des passagers </h1>

    <va-card >
    
      <div class="row align--center">
        <div class="flex xs12 md6">
          <va-input
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>
        </div>

        <div class="flex xs12 md3 offset--md3">
          <va-select
            v-model="perPage"
            :label="$t('tables.perPage')"
            :options="perPageOptions"
            noClear
          />
        </div>
      </div>
      
      
      <va-data-table
        :fields="fields"
        :data="filteredData"
        :per-page="parseInt(perPage)"
        >

      <template slot="actions" slot-scope="props">

        <va-popover placement="bottom"  title="Detail">
          <va-button @click="showPassengersDetails(props.rowData)" flat small color="gray" icon="fa fa-eye" />
        </va-popover>

      </template>

      </va-data-table>
  </va-card>

  
      <!-- modal showPassengersModal -->

      <va-modal size="large" v-model="showPassengersModal" title="Passager">

        <div class="row" v-if="passengerInfo">
          
          <div class="flex xs6">

            <div class="item" v-if="passengerInfo.info">
              <h6 for="">Photo </h6>
              <p><img :src="passengerInfo.info.photo" alt="" id="profil"></p>
            </div>

            <div class="item">
              <h6 for="">Date de désactivation</h6>
              <p>
                {{dataMoment(passengerInfo.disable_datetime)}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Dernière date de connexion </h6>
              <p>
                {{dataMoment(passengerInfo.lastlogin_datetime)}}
              </p> 
            </div>

            <div class="item" v-if="passengerInfo.info">
              <h6 for="">Type de piece</h6>
              <p>
                {{passengerInfo.info.id_type}}
              </p> 
            </div>

            <div class="item" v-if="passengerInfo.info">
              <h6 for="">Numéro de piece </h6>
              <p>
                {{passengerInfo.info.id_number}}
              </p> 
            </div>

          </div>

          <div class="flex xs6">

            <div class="item">
              <h6 for="">Nom complet </h6>
              <p>
                {{passengerInfo.full_name}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Surnom</h6>
              <p>
                {{passengerInfo.username}}
              </p> 
            </div>

            <div class="item" v-if="passengerInfo.info">
              <h6 for="">Ville </h6>
              <p>
                {{passengerInfo.info.city}}
              </p> 
            </div>

             <div class="item">
              <h6 for="">Téléphone </h6>
              <p>
                {{passengerInfo.phone}}
              </p> 
            </div>

            <div class="item">
              <h6 for="">Date de création</h6>
              <p>
                {{dataMoment(passengerInfo.created_date)}}
              </p> 
            </div>

        
          </div>
        </div>
      </va-modal>

  </div>

</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import service from "../../providers/service";

export default {
  data () {
    return {
      passengerInfo:[],
      showPassengersModal: false,
      passenger: null,
      term: null,
      data : [],
      perPage: '6',
      perPageOptions: ['4', '6', '10']
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'full_name',
          title: 'Nom complet',
          sortField: 'full_name'
        },
         {
          name: 'info.id_type',
          title: 'Type de piece',
          sortField: 'info.id_type'
        },
        {
          name: 'info.id_number',
          title: "Numéro de piece",
          sortField: 'info.id_number'
        },  
        {
          name: 'gender',
          title: "Genre",
          sortField: 'gender'
        },  
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        }
      ]
    },
     filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.data
      }

      return this.data.filter(item => {
        return item.full_name.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    

    dataMoment:function name(created_date) {
      return moment(created_date).format('DD/MM/YYYY')
    },
    

     search: debounce(function (term) {
      this.term = term
    }, 400),

    showPassengersDetails(passenger){
      this.passengerInfo = passenger;
      this.showPassengersModal = true;
    },

    edit (item) {
      alert('Edit User: ' + JSON.stringify(item))
    },

    remove (item) {

    },

    getListPassengers(){

      service.getPassengers(localStorage.userAccesstoken).then( res => {
      console.log(res);
      if(res.status === 200){

        this.data = res.data;
      }

    })
    }

  },
  mounted(){
    this.getListPassengers();
  }
}
</script>

<style lang="scss">

#profil{
    width: 7em;
    height: 7em;
    border-radius: 5em !important;
  }

.item{
    margin: 1em;
    background-color: #e4e7f5;
    padding: 1em;
  }
  
</style>